import { parseAsInteger, useQueryState } from 'nuqs';
import { usePurchaseOrderProductsTableColumns } from '@/features/purchase-order/hooks/use-purchase-order-products-table-columns';
import { useDataTable } from '@/hooks/use-data-table';
import { useGetPurchaseOrderLines } from '@/services/apis/queries/purchase-order/use-get-purchase-order-lines';
import type { PurchaseOrderProduct } from '@/types/core/purchase-order/purchase-order-product';

const PRODUCTS_PAGE_KEY = 'page';
const PRODUCTS_PER_PAGE_KEY = 'perPage';

export function usePurchaseOrderProductsTable(purchaseOrderId: string) {
  const columns = usePurchaseOrderProductsTableColumns();
  const [page] = useQueryState(
    PRODUCTS_PAGE_KEY,
    parseAsInteger.withDefault(1),
  );
  const [perPage] = useQueryState(
    PRODUCTS_PER_PAGE_KEY,
    parseAsInteger.withDefault(10),
  );
  const {
    data: lines,
    isPending,
    isFetching,
  } = useGetPurchaseOrderLines({
    id: purchaseOrderId,
    page,
    perPage,
  });

  const dataTable = useDataTable<PurchaseOrderProduct>({
    data: lines?.data ?? [],
    columns,
    getRowId: (row) => row.id,
    pageCount: lines?.maxPage ?? 0,
    renderFallbackValue: '-',
    initialState: {
      columnVisibility: {
        productWeight: false,
      },
    },
    enableSorting: false,
    enableRowSelection: true,
    queryKeys: {
      page: PRODUCTS_PAGE_KEY,
      perPage: PRODUCTS_PER_PAGE_KEY,
    },
  });

  return {
    ...dataTable,
    totalProductsCount: lines?.total ?? 0,
    isPending: isPending || isFetching,
  };
}
